import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import { message, Modal, Input, Row, Col } from 'antd-v4'
import { Track } from '../../../Track'
import { parseErrorMsg } from '../../../utilities/helpers'
import { LicensedProducerAPI, ILicensedProducerContract } from '@getgreenline/homi-shared'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  onClose: () => void
  updateLicensedProducers: (lp: ILicensedProducerContract) => void
  checkLicensedProducerExists: (licensedProducerName: string) => boolean
}

interface State {
  isSaving: boolean
  licensedProducerName: string
}

@inject('currentCompanyStore')
@observer
export class AddLPModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isSaving: false,
      licensedProducerName: '',
    }
  }

  addLicensedProducer = async () => {
    const { licensedProducerName } = this.state

    if (this.props.checkLicensedProducerExists(licensedProducerName)) {
      return message.error(`${licensedProducerName} licensed producer already exists.`)
    }

    await this.setState({ isSaving: true })

    try {
      const newLicensedProducer = await LicensedProducerAPI.addLicensedProducer(
        this.props.currentCompanyStore!.company!.id,
        { name: licensedProducerName },
      )
      Track.track('dashboard:licensed_producer_added', {})
      await this.props.updateLicensedProducers(newLicensedProducer)
      this.props.onClose()
    } catch (err) {
      message.error(
        parseErrorMsg(err) || 'There was an error saving licensed producer. Please try again.',
      )
    } finally {
      this.setState({ isSaving: false })
    }
  }

  render() {
    return (
      <Modal
        centered
        visible={true}
        onCancel={this.props.onClose}
        title='Add licensed producer'
        confirmLoading={this.state.isSaving}
        onOk={this.addLicensedProducer}
        okText='Save'
      >
        <Row className='d-flex align-items-center mb-3'>
          <Col span={8}>Licensed producer</Col>
          <Col span={16}>
            <Input
              style={{ flex: 2 }}
              value={this.state.licensedProducerName}
              placeholder='Type new licensed producer'
              onChange={(e) => this.setState({ licensedProducerName: e.target.value })}
            />
          </Col>
        </Row>
      </Modal>
    )
  }
}
